import {useBlockInfluencerMutation} from "@/api/companyApi";
import ProhibitedIcon from "@/assets/colorable/prohibited.svg?react";
import ConfirmationModal from "@/components/Common/ConfirmationModal";
import {blockInfluencerModalAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const BlockInfluencerModal: FC = () => {
  const {t} = useTranslation("groups");
  const [modalData, setModalData] = useAtom(blockInfluencerModalAtom);
  const blockMutation = useBlockInfluencerMutation({
    companyId: modalData?.companyId!,
    onSuccessCallback: () => setModalData(null),
  });

  return (
    <ConfirmationModal
      Icon={ProhibitedIcon}
      confirmButtonText={t("block_influencer")}
      description={t("block_influencer_description")}
      isPending={blockMutation.isPending}
      onClose={() => setModalData(null)}
      onConfirm={() =>
        blockMutation.mutate({
          campaignApplicationId: modalData?.campaignApplicationId,
          influencerId: modalData?.influencerId!,
        })
      }
      title={t("block_influencer_title")}
    />
  );
};

export default BlockInfluencerModal;
